import React, { useState } from 'react';
import { supabase } from '../../supabaseClient';

const ElegirNickname = ({ session, onNicknameGuardado }) => {
  const [nickname, setNickname] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleGuardar = async (e) => {
    e.preventDefault();
    setError('');
    const nick = nickname.trim();
    if (!nick) { setError('El nickname no puede estar vacío'); return; }
    if (nick.length < 3) { setError('Mínimo 3 caracteres'); return; }
    if (nick.length > 20) { setError('Máximo 20 caracteres'); return; }
    if (!/^[a-zA-Z0-9_]+$/.test(nick)) { setError('Solo letras, números y guión bajo'); return; }

    setLoading(true);

    // Verificar si ya existe
    const { data: existente } = await supabase
      .from('perfiles').select('id').eq('nickname', nick).maybeSingle();
    if (existente && existente.id !== session.user.id) {
      setError('Ese nickname ya está en uso, elegí otro');
      setLoading(false);
      return;
    }

    const { error: err } = await supabase
      .from('perfiles')
      .upsert({ id: session.user.id, nickname: nick }, { onConflict: 'id' });

    if (err) { setError('Error al guardar: ' + err.message); setLoading(false); return; }

    onNicknameGuardado(nick);
  };

  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: '#0a0f19',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 99999,
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #080d14, #0f172a)',
        border: '1px solid #1e293b',
        borderRadius: '20px', padding: '48px 40px',
        width: '100%', maxWidth: '420px',
        textAlign: 'center',
        boxShadow: '0 0 60px rgba(0,242,255,0.08)',
      }}>

        {/* Icono */}
        <div style={{ fontSize: '2.5rem', marginBottom: '16px' }}></div>

        <h1 style={{ color: '#fff', margin: '0 0 8px', fontSize: '1.6rem', letterSpacing: '1px' }}>
          Elegí tu nickname
        </h1>
        <p style={{ color: '#475569', margin: '0 0 32px', fontSize: '0.85rem', lineHeight: 1.5 }}>
          Es tu identidad en el juego. Vas a aparecer así en los torneos, el palmarés y el tablero.
          <br/>
          <span style={{ color: '#334155', fontSize: '0.78rem' }}>Solo letras, números y guión bajo. No se puede cambiar después.</span>
        </p>

        <form onSubmit={handleGuardar} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <input
            type="text"
            placeholder="ej: Chino10, el_rey, GolazoFC"
            value={nickname}
            onChange={e => setNickname(e.target.value)}
            maxLength={20}
            autoFocus
            style={{
              padding: '14px 16px', background: '#0a0f19',
              border: `1px solid ${error ? '#ff4444' : '#1e293b'}`,
              borderRadius: '10px', color: '#fff',
              fontSize: '1.1rem', textAlign: 'center',
              letterSpacing: '1px', outline: 'none',
              transition: '0.2s',
            }}
            onFocus={e => e.target.style.borderColor = '#00f2ff'}
            onBlur={e => e.target.style.borderColor = error ? '#ff4444' : '#1e293b'}
          />

          {/* Preview del nickname */}
          {nickname.trim().length >= 3 && !error && (
            <p style={{ color: '#00f2ff', fontSize: '0.8rem', margin: 0 }}>
              Así vas a aparecer: <strong>{nickname.trim()}</strong>
            </p>
          )}

          {error && (
            <p style={{ color: '#ff4444', fontSize: '0.8rem', margin: 0, padding: '8px', background: '#ff444411', borderRadius: '6px', border: '1px solid #ff444433' }}>
              {error}
            </p>
          )}

          <button type="submit" disabled={loading || nickname.trim().length < 3}
            style={{
              padding: '14px',
              background: nickname.trim().length >= 3 && !loading ? '#00f2ff' : '#1e293b',
              color: nickname.trim().length >= 3 && !loading ? '#000' : '#475569',
              border: 'none', borderRadius: '10px',
              fontWeight: 'bold', fontSize: '1rem',
              cursor: nickname.trim().length >= 3 && !loading ? 'pointer' : 'default',
              transition: '0.2s', marginTop: '8px',
              textShadow: 'none',
            }}>
            {loading ? 'Guardando...' : '¡Listo, a jugar!'}
          </button>
        </form>

        <p style={{ color: '#1e293b', fontSize: '0.7rem', margin: '20px 0 0' }}>
          {session?.user?.email}
        </p>
      </div>
    </div>
  );
};

export default ElegirNickname;